import {API_URLS} from '@px/const/urls';
import {http} from '@px/helper/http';

export const memberApi = {
  membershipInfo() {
    return http.get(API_URLS.MEMBERSHIP_INFO, {});
  },
  receive(params) {
    return http.post(API_URLS.RECEIVE, {params});
  },
  baseMemberInfo() {
    return http.get(API_URLS.BASE_MEMBER_INFO, {});
  },
  getUserKycInfo() {
    return http.get(API_URLS.USER_KYC_INFO, {});
  },
};
